export const deliverySources = {
  EXISTING: "Boletos existentes",
  INITIAL: "Primeiro envio",
  D2: "Lembrete D-2",
  COLLECTION: "Régua de cobrança",
  VOICE: "Pedido à Donna",
};
export const deliveryStates = {
  PENDING: "Aguardando processamento",
  SCHEDULED: "Programado",
  RETRY: "Nova tentativa prevista",
  RESERVED: "Reservado para execução",
  IN_FLIGHT: "Em processamento",
  ACCEPTED: "Aceito pelo provedor",
  DELIVERED: "Entrega confirmada",
  READ: "Leitura confirmada",
  FAILED: "Falha confirmada",
  UNCERTAIN: "Resultado a conferir",
  HELD: "Retido para conferência",
  REVIEW_REQUIRED: "Revisão necessária",
  CANCELLED: "Cancelado",
};
const groups = {
  queue: ["PENDING", "SCHEDULED", "RETRY"],
  history: ["ACCEPTED", "DELIVERED", "READ"],
  attention: [
    "RESERVED",
    "IN_FLIGHT",
    "FAILED",
    "UNCERTAIN",
    "HELD",
    "REVIEW_REQUIRED",
    "CANCELLED",
  ],
};
const count = (n) => Number.isSafeInteger(n) && n >= 0,
  time = (v) => typeof v === "string" && Number.isFinite(Date.parse(v)),
  optional = (v, max) =>
    v === null || (typeof v === "string" && v.length <= max);
export function validDeliveryMonitor(d, f, page, now = Date.now()) {
  if (
    d?.source !== "FINANCIAL_DELIVERY_LEDGERS" ||
    d.sourceEnvironment !== "production" ||
    d.scope !== "RECORDED_DISPATCH_JOBS_ONLY" ||
    d.readOnly !== true ||
    d.dispatchAllowed !== false ||
    !time(d.generatedAt) ||
    Date.parse(d.generatedAt) > now + 60000 ||
    !time(d.expiresAt) ||
    Date.parse(d.expiresAt) <= now ||
    Date.parse(d.expiresAt) <= Date.parse(d.generatedAt)
  )
    return false;
  if (
    !d.filters ||
    d.filters.dateBasis !== "REGISTRATION_UTC" ||
    Object.keys(f).some((k) => d.filters[k] !== f[k]) ||
    !Array.isArray(d.coverage) ||
    d.coverage.length !== 5 ||
    new Set(d.coverage).size !== 5 ||
    d.coverage.some(
      (s) => !Object.prototype.hasOwnProperty.call(deliverySources, s),
    )
  )
    return false;
  if (
    !d.summary ||
    !["queue", "history", "attention", "all"].every((k) =>
      count(d.summary[k]),
    ) ||
    d.summary.queue + d.summary.history + d.summary.attention !== d.summary.all
  )
    return false;
  const p = d.pagination;
  if (
    !p ||
    p.page !== page ||
    p.pageSize !== 25 ||
    !count(p.total) ||
    p.total !== d.summary[f.view] ||
    p.totalPages !== Math.ceil(p.total / 25) ||
    !Array.isArray(d.items) ||
    d.items.length > 25 ||
    d.items.length > p.total
  )
    return false;
  const keys = new Set();
  return d.items.every((r) => {
    const key = r.source + ":" + r.id;
    if (
      ["ACCEPTED", "DELIVERED", "READ", "FAILED"].includes(r.state) &&
      !r.providerMessageId
    )
      return false;
    if (
      ["DELIVERED", "READ"].includes(r.state) &&
      (r.source !== "COLLECTION" || r.channel !== "whatsapp")
    )
      return false;
    const ok =
      Object.prototype.hasOwnProperty.call(deliverySources, r.source) &&
      typeof r.id === "string" &&
      r.id.length > 0 &&
      r.id.length <= 128 &&
      !keys.has(key) &&
      Object.prototype.hasOwnProperty.call(deliveryStates, r.state) &&
      ["email", "whatsapp"].includes(r.channel) &&
      optional(r.paymentId, 128) &&
      optional(r.customerId, 128) &&
      optional(r.reasonCode, 64) &&
      optional(r.providerMessageId, 255) &&
      optional(r.stage, 64) &&
      optional(r.scheduledDate, 10) &&
      (!r.scheduledDate || /^20\d{2}-\d{2}-\d{2}$/.test(r.scheduledDate)) &&
      time(r.createdAt) &&
      time(r.updatedAt) &&
      r.recipient === null &&
      r.recipientEvidence === "NOT_RETAINED_IN_LEDGER" &&
      r.deliveryConfirmed === ["DELIVERED", "READ"].includes(r.state) &&
      (!f.source || f.source === r.source) &&
      (!f.state || f.state === r.state) &&
      (!f.paymentId || f.paymentId === r.paymentId) &&
      (f.view === "all" || groups[f.view]?.includes(r.state));
    keys.add(key);
    return !!ok;
  });
}
export function validDeliveryContext(c, row, now = Date.now()) {
  return !!(
    c &&
    c.source === "ASAAS" &&
    c.sourceEnvironment === "production" &&
    c.readOnly === true &&
    c.basis === "CURRENT_ASAAS_PAYMENT" &&
    c.recordSource === row.source &&
    c.recordId === row.id &&
    c.paymentId === row.paymentId &&
    /^cus_[A-Za-z0-9_-]{3,124}$/.test(c.customerId || "") &&
    (!row.customerId || c.customerId === row.customerId) &&
    typeof c.customerName === "string" &&
    c.customerName.trim() &&
    c.customerName.length <= 200 &&
    !Array.from(c.customerName).some(
      (char) => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127,
    ) &&
    typeof c.amount === "string" &&
    /^(0|[1-9]\d{0,12})\.\d{2}$/.test(c.amount) &&
    c.currency === "BRL" &&
    time(c.generatedAt) &&
    Date.parse(c.generatedAt) <= now + 60000 &&
    time(c.expiresAt) &&
    Date.parse(c.expiresAt) > now &&
    Date.parse(c.expiresAt) > Date.parse(c.generatedAt) &&
    (c.installmentStatus === "AVAILABLE"
      ? c.installment &&
        Number.isSafeInteger(c.installment.number) &&
        Number.isSafeInteger(c.installment.total) &&
        c.installment.number >= 1 &&
        c.installment.number <= c.installment.total &&
        c.installment.total <= 10000
      : ["UNAVAILABLE", "NOT_APPLICABLE"].includes(c.installmentStatus) &&
        c.installment === null)
  );
}
export const deliveryInstallmentLabel = (c) =>
  c?.installmentStatus === "AVAILABLE"
    ? `${c.installment.number} de ${c.installment.total}`
    : c?.installmentStatus === "NOT_APPLICABLE"
      ? "Sem parcelamento informado"
      : "Não disponível";
export function deliveryMonitorCsv(d) {
  const q = (v) =>
    '"' +
    String(v ?? "")
      .replace(/^[\s]*[=+\-@]/, "'$&")
      .replace(/"/g, '""') +
    '"';
  return (
    "\uFEFF" +
    [
      [
        "Acompanhamento de envios financeiros",
        "Página",
        d.pagination.page,
        "Consulta",
        d.generatedAt,
      ],
      [
        "Escopo",
        "Somente registros desta página; SMTP aceito não confirma entrega",
      ],
      [
        "Fluxo",
        "Registro",
        "Cobrança",
        "Cliente (referência)",
        "Nome do cliente",
        "Valor atual da cobrança (BRL)",
        "Parcela",
        "Consulta dos dados atuais",
        "Dados consultados em",
        "Canal",
        "Etapa",
        "Situação",
        "Programado para",
        "Criado em",
        "Atualizado em",
        "Recibo do provedor",
        "Motivo",
        "Destinatário",
      ],
      ...d.items.map((r) => [
        deliverySources[r.source],
        `${r.source}:${r.id}`,
        r.paymentId,
        r.customerId ||
          (validDeliveryContext(r.billingContext, r)
            ? r.billingContext.customerId
            : ""),
        validDeliveryContext(r.billingContext, r)
          ? r.billingContext.customerName
          : "",
        validDeliveryContext(r.billingContext, r)
          ? r.billingContext.amount
          : "",
        validDeliveryContext(r.billingContext, r)
          ? deliveryInstallmentLabel(r.billingContext)
          : "Não disponível",
        validDeliveryContext(r.billingContext, r)
          ? "Dados atuais do Asaas"
          : r.billingStatus === "LOADING"
            ? "Consultando"
            : "Não disponível",
        validDeliveryContext(r.billingContext, r)
          ? r.billingContext.generatedAt
          : "",
        r.channel,
        r.stage,
        deliveryStates[r.state],
        r.scheduledDate,
        r.createdAt,
        r.updatedAt,
        r.providerMessageId,
        r.reasonCode,
        "Não retido no registro histórico",
      ]),
    ]
      .map((r) => r.map(q).join(";"))
      .join("\r\n")
  );
}

const reasons = {
  APPROVAL_REVOKED: "Aprovação revogada",
  MISSED_DELIVERY_DATE: "Data autorizada de envio ultrapassada",
  MISSED_WINDOW: "Janela de contato ultrapassada",
  PAID_OR_CANCELLED: "Cobrança paga ou cancelada no provedor",
  PAYMENT_SETTLED_OR_CANCELLED: "Cobrança paga ou cancelada no provedor",
  PAYMENT_SETTLED_BEFORE_TRANSPORT:
    "Cobrança deixou de estar aberta antes do envio",
  TRANSPORT_OUTCOME_UNCERTAIN: "Resultado do envio precisa de conferência",
  STOPPED_BEFORE_TRANSPORT: "Envio interrompido antes de contatar o provedor",
  PROVIDER_OUTCOME_REQUIRES_REVIEW:
    "Resultado do provedor precisa de conferência",
};
export const deliveryReasonLabel = (code) =>
  !code
    ? "Não registrado"
    : Object.prototype.hasOwnProperty.call(reasons, code)
      ? reasons[code]
      : "Motivo sem descrição neste histórico";
const stageLabels = {
  INITIAL: "Primeiro envio",
  D2: "Lembrete D-2",
  REQUESTED_ON_CALL: "Solicitado na ligação",
  D_MINUS_3: "D-3",
  D_MINUS_1: "D-1",
  DUE_TODAY: "Vencimento",
  D_PLUS_1: "D+1",
  D_PLUS_5: "D+5",
};
export const deliveryStageLabel = (stage) =>
  Object.prototype.hasOwnProperty.call(stageLabels, stage)
    ? stageLabels[stage]
    : "Etapa registrada";
